<template>
  <div :id="combo.entity_code" class="product-card product-card-grid combo-card combo-card-grid">
    <div class="product-card-grid-header">
      <div class="combo-card-discount" v-if="combo.discount">{{ combo.discount }}</div>
      <div class="product-card-title product-card-grid-title">
        {{ combo.title }}
      </div>
      <div class="zoom" @click="openCombo(catalogElement)" :id="combo.source_action_id">
        <span class="pp-icon pp-icon-loupe"></span>
      </div>
      <div class="product-card-grid-image" :style="{ backgroundImage: `url(${combo.picture})` }"></div>
    </div>
    <div class="product-card-grid-buttons">
      <div class="product-choose-button button-lg" @click="openCombo(catalogElement)">
        <span class="button-value">{{phrases.CATALOG_COMBO_BUY_BUTTON}}</span>
        <span class="button-price">{{ combo.price }}&#8381;</span>
      </div>
    </div>

    <div class="product-card-grid-footer" ref="footer">
      <div class="product-card-button-action" @click="openCombo(catalogElement)">
        <span class="pp-icon pp-icon-basket-move"></span>
        <span class="product-card-button-action-title">{{phrases.CATALOG_COMBO_BUY_BUTTON}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import ComboUtils from "@/components/combos/ComboUtils.vue";

  export default {
    name: "Combo",
    components: {},
    props: {
      catalogElement: {},
    },
    mixins: [ComboUtils],
    computed:{
      combo: function (){
        return this.catalogElement.element;
      }
    },
    mounted() {
      const component = this;
      if(component.entityInUrlPath(component.catalogElement)){
        component.openCombo(component.catalogElement);
      }
    }
  }
</script>

<style lang="scss">
  .combo-card:hover .product-card-grid-footer{
      bottom: 0;
      z-index: 16;
  }
  .combo-card-discount {
      background-color: #fd813d;
      position: absolute;
      border-radius: 1rem;
      padding: 0.25rem 0.5rem;
      font-family: "Panton ExtraBold", sans-serif;
      right: 1rem;
      top: 1rem;
      z-index: 9;
      display: inline-flex;
      box-sizing: border-box;
      font-size: 1rem;
      line-height: 1rem;
  }

  @media screen and ((max-width:920px)) {
    .combo-card-grid .combo-card-discount{
      top: 0.5rem;
      right: 0.5rem;
    }
  }
</style>